import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";

// ============================================================
// PAGES PUBLIQUES
// ============================================================
import HomePage from "../pages/Dashboard/HomePage";
import Login from "../pages/Auth/Login";
import ResetPassword from "../pages/RH/ResetPassword";
import FirstLoginPassword from "../pages/RH/FirstLoginPassword";
// ============================================================
// ESPACE EMPLOYE
// ============================================================
import EmployeeDashboard from "../pages/Employee/EmployeeDashboard";
import CreateLeaveRequest from "../pages/Leave/CreateLeaveRequest";
import MyLeaveRequests from "../pages/Leave/MyLeaveRequests";

// ============================================================
// MANAGER
// ============================================================
import ManagerDashboard from "../pages/Manager/ManagerDashboard";
import TeamLeaveRequests from "../pages/Manager/TeamLeaveRequests";

// ============================================================
// RH - LAYOUT
// ============================================================
import RHLayout from "../components/layout/RHLayout";

// ============================================================
// RH - DASHBOARD
// ============================================================
import RHDashboard from "../pages/RH/RHDashboard";

// ============================================================
// RH - EMPLOYES
// ============================================================
import EmployeesManagement from "../pages/RH/EmployeesManagement";
import EmployeeNew from "../pages/RH/EmployeeNew";
import EmployeeEdit from "../pages/RH/EmployeeEdit";

// ============================================================
// RH - CONGES
// ============================================================
import LeaveRequestsRH from "../pages/RH/LeaveRequestsRH";
import LeaveHistoryRH from "../pages/RH/LeaveHistoryRH";
import LeaveAttachmentPage from "../pages/RH/LeaveAttachmentPage";
import LeaveEdit from "../pages/RH/LeaveEdit";

// ============================================================
// RH - ARTICLES
// ============================================================
import ArticlesList from "../pages/RH/ArticlesList";

// ============================================================
// RH - CONTRATS
// ============================================================
import ContratsList from "../pages/RH/ContratsList";
import ContratForm from "../pages/RH/ContratForm";

// ============================================================
// RH - CALENDRIER
// ============================================================
import RHCalendarPage from "../pages/RH/RHCalendarPage";
import CalendarEventNew from "../pages/RH/CalendarEventNew";
import CalendarEventDetail from "../pages/RH/CalendarEventDetail";
import CalendarEventEdit from "../pages/RH/CalendarEventEdit";

// ============================================================
// RH - JOURS FERIES
// ============================================================
import HolidaysManagement from "../pages/RH/HolidaysManagement";

// ============================================================
// RH - AUDIT
// ============================================================
import AuditLogs from "../pages/RH/AuditLogs";

// ============================================================
// RH - NOTIFICATIONS
// ============================================================
import Alertes from "../pages/RH/Alertes";
import EmployeeAlertes from "../pages/RH/EmployeeAlertes";

// ============================================================
// RH - ESPACE PERSONNEL
// ============================================================
import MesContrats from "../pages/RH/MesContrats";
import MonProfil from "../pages/RH/MonProfil";

// ============================================================
// RH - RECRUTEMENT
// ============================================================
import JobOffers from "../pages/RH/JobOffers";
import JobOfferNew from "../pages/RH/JobOfferNew";
import JobOfferEdit from "../pages/RH/JobOfferEdit";

import Applications from "../pages/RH/Applications";
import ApplicationNew from "../pages/RH/ApplicationNew";
import ApplicationEdit from "../pages/RH/ApplicationEdit";

// ============================================================
// RH - ENTRETIENS
// ============================================================
import InterviewScheduling from "../pages/RH/InterviewScheduling";
import InterviewPreparation from "../pages/RH/InterviewPreparation";
import InterviewMode from "../pages/RH/InterviewMode";

// ============================================================
// RH - IA / CV
// ============================================================
import CVRanking from "../pages/RH/CVRanking";
import AIDashboard from "../pages/RH/AIDashboard";
import AssistantRHV2Page from "../pages/AssistantRHV2Page";

import LeaveAnnualReport from "../pages/RH/LeaveAnnualReport";
// ============================================================
// APP ROUTES
// ============================================================



const AppRoutes = () => {
  return (
    <Routes>

      {/* ======================================================
          ROUTES PUBLIQUES
          ====================================================== */}

      <Route
        path="/"
        element={<HomePage />}
      />

      <Route
        path="/login"
        element={<Login />}
      />

      <Route
          path="/reset-password"
          element={<ResetPassword />}
      />

      <Route
          path="/first-login-password"
          element={<FirstLoginPassword />}
      />
      {/* ======================================================
          ESPACE EMPLOYE
          ====================================================== */}

      <Route
        path="/employee/dashboard"
        element={
          <ProtectedRoute
            allowedRoles={[
              "employee",
              "manager",
              "rh",
              "admin",
            ]}
          >
            <EmployeeDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/employee/leave-create"
        element={
          <ProtectedRoute
            allowedRoles={[
              "employee",
              "manager",
              "rh",
              "admin",
            ]}
          >
            <CreateLeaveRequest />
          </ProtectedRoute>
        }
      />

      <Route
        path="/employee/leave-history"
        element={
          <ProtectedRoute
            allowedRoles={[
              "employee",
              "manager",
              "rh",
              "admin",
            ]}
          >
            <MyLeaveRequests />
          </ProtectedRoute>
        }
      />


      {/* ======================================================
          MANAGER
          ====================================================== */}

      <Route
        path="/manager/dashboard"
        element={
          <ProtectedRoute
            allowedRoles={["manager"]}
          >
            <ManagerDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/manager/leaves"
        element={
          <ProtectedRoute
            allowedRoles={["manager"]}
          >
            <TeamLeaveRequests />
          </ProtectedRoute>
        }
      />


      {/* ======================================================
          ESPACE RH
          ====================================================== */}

    <Route
  path="/rh"
  element={
    <ProtectedRoute
      allowedRoles={["rh", "admin"]}
    >
      <RHLayout />
    </ProtectedRoute>
  }
>

        {/* ====================================================
            DASHBOARD
            ==================================================== */}

        <Route
          path="dashboard"
          element={<RHDashboard />}
        />


        {/* ====================================================
            EMPLOYES
            ==================================================== */}

        <Route
          path="employees"
          element={<EmployeesManagement />}
        />

        <Route
          path="employees/new"
          element={<EmployeeNew />}
        />

        <Route
          path="employees/:id/edit"
          element={<EmployeeEdit />}
        />


        {/* ====================================================
            CONGES
            ==================================================== */}

        <Route
          path="leaves"
          element={<LeaveRequestsRH />}
        />

        <Route
          path="leaves/history"
          element={<LeaveHistoryRH />}
        />

        <Route
          path="leaves/:id/attachment"
          element={<LeaveAttachmentPage />}
        />

        <Route
          path="leaves/:id/edit"
          element={<LeaveEdit />}
        />


        {/* ====================================================
            ARTICLES
            ==================================================== */}

       <Route
    path="articles"
    element={<ArticlesList />}
  />


        {/* ====================================================
            CONTRATS
            ==================================================== */}

        <Route
          path="contracts"
          element={<ContratsList />}
        />

        <Route
          path="contracts/new"
          element={<ContratForm />}
        />

        <Route
          path="contrats/modifier/:id"
          element={<ContratForm />}
        />


        {/* ====================================================
            CALENDRIER
            ==================================================== */}

        <Route
          path="calendar"
          element={<RHCalendarPage />}
        />

        <Route
          path="calendar/events/new"
          element={<CalendarEventNew />}
        />

        <Route
          path="calendar/events/:id"
          element={<CalendarEventDetail />}
        />

        <Route
          path="calendar/events/:id/edit"
          element={<CalendarEventEdit />}
        />


        {/* ====================================================
            JOURS FERIES
            ==================================================== */}

        <Route
          path="holidays"
          element={<HolidaysManagement />}
        />


        {/* ====================================================
            AUDIT / HISTORIQUE
            ==================================================== */}

        <Route
          path="audit"
          element={<AuditLogs />}
        />


        {/* ====================================================
            ALERTES / NOTIFICATIONS
            ==================================================== */}

        <Route
          path="notifications"
          element={<Alertes />}
        />

        <Route
          path="alertes"
          element={<Alertes />}
        />


        {/* ====================================================
            MES CONTRATS
            ==================================================== */}

        <Route
          path="my-contracts"
          element={<MesContrats />}
        />


        {/* ====================================================
            MON PROFIL
            ==================================================== */}

        <Route
          path="profile"
          element={<MonProfil />}
        />


        {/* ====================================================
            ALERTES EMPLOYE
            ==================================================== */}

        <Route
          path="employee-alerts"
          element={<EmployeeAlertes />}
        />


        {/* ====================================================
            RECRUTEMENT
            ==================================================== */}

        <Route
          path="job-offers"
          element={<JobOffers />}
        />

        <Route
          path="job-offers/new"
          element={<JobOfferNew />}
        />

        <Route
          path="job-offers/:id/edit"
          element={<JobOfferEdit />}
        />


        {/* ====================================================
            CANDIDATURES
            ==================================================== */}

        <Route
          path="applications"
          element={<Applications />}
        />

        <Route
          path="applications/new"
          element={<ApplicationNew />}
        />

        <Route
          path="applications/:id/edit"
          element={<ApplicationEdit />}
        />


        {/* ====================================================
            ENTRETIENS
            ==================================================== */}

        <Route
          path="interview-schedule/:applicationId"
          element={<InterviewScheduling />}
        />

        <Route
          path="interview-preparation"
          element={<InterviewPreparation />}
        />

        <Route
          path="interview-mode/:interviewId"
          element={<InterviewMode />}
        />


        {/* ====================================================
            CV / IA
            ==================================================== */}

        <Route
          path="cv-ranking"
          element={<CVRanking />}
        />

        <Route
          path="ai-dashboard"
          element={<AIDashboard />}
        />

        <Route
          path="assistant"
          element={<AssistantRHV2Page />}
        />


        {/* ====================================================
            REDIRECTION ESPACE EMPLOYE
            ==================================================== */}

        <Route
          path="employee"
          element={
            <Navigate
              to="/employee/dashboard"
              replace
            />
          }
        />

      </Route>


      {/* ======================================================
          FALLBACK
          ====================================================== */}

      <Route
        path="*"
        element={
          <Navigate
            to="/"
            replace
          />
        }
      />

      <Route
  path="/rh/profile"
  element={<MonProfil />}
/>

<Route
  path="/employee/profile"
  element={<MonProfil />}
/>

<Route
  path="/manager/profile"
  element={<MonProfil />}
/>


<Route
  path="/rh/leave-annual-report"
  element={<LeaveAnnualReport />}
/>

    </Routes>
  );
};

export default AppRoutes;